// Limiares e cores da ecocondução partilhados pelos widgets agregados.
// Em sync com screens/vehicles-gps/components/ecoDriving/EcoDriving.tsx e GetEcoDrivingRankingAsync (backend).
export const ZONE_SAFE_MAX = 5;
export const ZONE_WARNING_MAX = 15;

export const ECO_SAFE_COLOR = '#73C25C';
export const ECO_WARNING_COLOR = '#F3A70D';
export const ECO_DANGER_COLOR = '#D22222';

export const calcEcoColor = (val: number): string => {
	if (val <= ZONE_SAFE_MAX) return ECO_SAFE_COLOR;
	if (val > ZONE_SAFE_MAX && val < ZONE_WARNING_MAX) return ECO_WARNING_COLOR;
	return ECO_DANGER_COLOR;
};

// O backend envia datas UTC à meia-noite do dia 1 (ex: "2025-09-01T00:00:00Z"). Em fusos a leste de
// UTC, getMonth()/getDate() locais devolvem o mês anterior. Esta helper extrai ano/mês em UTC e
// devolve uma Date local ao meio-dia do dia 15 desse mês, eliminando o drift no eixo.
export const normalizeMonthDate = (raw: string | Date): Date => {
	const d = raw instanceof Date ? raw : new Date(raw);
	return new Date(d.getUTCFullYear(), d.getUTCMonth(), 15, 12, 0, 0);
};

export const toMonthKey = (d: Date): string => `${d.getFullYear()}-${d.getMonth()}`;
